import { EVENT_COLLAPSE_TOGGLE } from './constants'

export default {
  /* Add Click Event Listener to `el` on mounted as we only
   * care if the object was clicked
   */
  bind(el, binding, vnode) {
    el.addEventListener('click', (() => toggleDirective(el, binding, vnode)));
  },

  // Remove Event Listener on destroy.
  unbind(el, binding, vnode) {
    el.removeEventListener('click', (() => toggleDirective(el, binding, vnode)));
  }
}

function toggleDirective(el, binding, vnode) {
  let resolvedId = Object.keys(binding.modifiers)[0]
  if (!resolvedId){
    resolvedId = binding.value
  }
  vnode.context.$root.$emit(EVENT_COLLAPSE_TOGGLE, { id: `${resolvedId}__fb_collapse__` })
}
